import React, { useState } from "react";
import { LuCopy, LuCheck, LuMail } from "react-icons/lu";

export default function Footer() {
    const [copied, setCopied] = useState(false);

    const handleCopy = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        navigator.clipboard.writeText("support@igleads.co");
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <footer className="py-5 border-t border-slate-100/80 bg-slate-50/40 backdrop-blur-md mt-auto relative z-10">
            <div className="max-w-7xl mx-auto px-6 md:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
                <p className="text-xs text-slate-400 font-medium tracking-tight">
                    &copy; {new Date().getFullYear()} <span className="font-semibold text-slate-600">IG Leads</span>. All rights reserved.
                </p>
                <div className="flex flex-wrap items-center justify-center gap-6">
                    <a href="/support" className="text-xs text-violet-600 hover:text-violet-700 font-bold transition-all hover:-translate-y-0.5 duration-200">
                        Support & Help
                    </a>
                    <span className="h-3 w-px bg-slate-200" />
                    
                    {/* Interactive email pill */}
                    <div className="relative group">
                        <div className="absolute -inset-0.5 bg-gradient-to-r from-violet-500 to-fuchsia-500 rounded-full blur-xs opacity-0 group-hover:opacity-20 transition duration-300"></div>
                        <div className="relative flex items-center gap-3 pl-3 pr-2 py-1 bg-white border border-slate-200/60 rounded-full shadow-xs hover:border-violet-300 transition-all duration-300">
                            {/* Pulse indicator */}
                            <span className="relative flex h-2 w-2">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                            </span>
                            
                            <a href="mailto:support@igleads.co" className="text-xs font-semibold text-slate-600 hover:text-violet-600 transition-colors flex items-center gap-1.5">
                                <LuMail size={13} className="text-slate-400 group-hover:text-violet-500 transition-colors" />
                                <span>support@igleads.co</span>
                            </a>
                            
                            <button
                                onClick={handleCopy}
                                className="ml-1 p-1 rounded-full text-slate-400 hover:text-violet-600 hover:bg-slate-100 transition-all cursor-pointer relative flex items-center justify-center"
                                title="Copy email address"
                            >
                                {copied ? (
                                    <LuCheck size={12} className="text-emerald-500 scale-110 transition-transform" />
                                ) : (
                                    <LuCopy size={12} className="group-hover:scale-110 transition-transform" />
                                )}
                                {copied && (
                                    <span className="absolute -top-9 left-1/2 -translate-x-1/2 bg-slate-800 text-white text-[10px] py-1 px-2 rounded-md shadow-lg pointer-events-none transition-all duration-200 font-bold whitespace-nowrap z-50">
                                        Copied!
                                    </span>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
